import { DEFAULT_TINYMCE_OPTIONS } from '../../../../shared/default-tinymce-options';

export const FOD_OUTBOUND_API_TINYMCE_OPTIONS = {
    ...DEFAULT_TINYMCE_OPTIONS,

    selector: '#tinyMce',
    content_css: '/assets/css/fod-outbound-api-tinymce.css',
    height: '400px',
    fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt',

    plugins: [
        'preview',
        'fullscreen',
        'code'
    ],

    toolbar1: 'fontsizeinput | searchreplace | code fullscreen',
    //toolbar1: 'blocks fontsizeinput | outdent indent | searchreplace | charmap subscript superscript | removeformat',
    //toolbar2: 'bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | table | undo redo | visualchars visualblocks | code fullscreen',
    //toolbar3: 'pdfPreview | vPessoas vLocais vDatas vForm',
};
